import React from 'react';
import PropTypes from 'prop-types';

function HitHeadline({headline}) {
    return (<h4 className="hit-headline hidden-sm hidden-xs hidden-mini hidden-gallery">{headline}</h4>);
}

HitHeadline.propTypes = {
    headline: PropTypes.string
};

export default HitHeadline;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitHeadline/HitHeadline.js